<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<!-- <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div> -->

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:81px; margin-bottom:40px;">
    <strong>UMOWA O ŚWIADCZENIE USŁUG NAUCZANIA JĘZYKA OBCEGO</strong>
</p>
<p style="margin-bottom:40px;">
    zawarta w dniu {{ dataPodpisania }} w {{ miejscePodpisania }} dalej: (,,Umowa''), pomiędzy:
</p>
<p>
  <b>Tutore Poland Sp. z o.o.,</b> z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod numerem KRS 0000670834, NIP:727-28-12-193, REGON: 366891567, kapitał zakładowy 1 664 600,00 złotych, reprezentowaną przez:
</p>
<p>
<strong>{{ zamawiajacy }}</strong>
</p>
<p class="commented-text mb-1">
  /pełnomocnik niniejszym oświadcza, że udzielone pełnomocnictwa jest ważne, skuteczne i nie zostało odwołane/
</p>
<p class="commented-text">
  /odpis pełnomocnictwa wraz z informacją odpowiadającą odpisowi pełnemu z rejestru przedsiębiorców pobraną na podstawie art. 4 ust. 4aa ustawy z dnia 20 sierpnia 1997 r. o Krajowym Rejestrze Sądowym stanowi Załącznik nr 4 do niniejszej Umowy/
</p>
<p>zwaną w dalszej części Umowy <b>,,Zleceniodawcą''</b></p>
<p>a</p>
<p>
  <b>Fundacją Rozwoju Przedsiębiorczości &quot;Twój StartUp&quot;</b> z siedzibą w Warszawie (00-503) przy ulicy Żurawiej 6/12, lok. 766 wpisaną do rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla m.st. Warszawy w Warszawie, XII Wydział Gospodarczy KRS pod numerem KRS: 0000442857, NIP: 5213641211, REGON:146433467, reprezentowaną przez:
  <p>Michała Jeziorskiego – Prezesa Zarządu,</p>
  <p class="commented-text">
    /informacja odpowiadającą odpisowi pełnemu z rejestru stowarzyszeń, innych organizacji społecznych i zawodowych, fundacji oraz publicznych zakładów opieki zdrowotnej przedsiębiorców pobrana na podstawie art. 4 ust. 4aa ustawy z dnia 20 sierpnia 1997 r. o Krajowym Rejestrze Sądowym stanowi Załącznik nr 5 do niniejszej Umowy/
  </p>
  <p>zwaną w dalszej części umowy <strong>,,Fundacją''</strong></p>
  <p>zwanymi łącznie <strong>,,Stronami''</strong>, a każdy z osobna <strong>,,Stroną''</strong></p>
</p>

<p align="center" style="margin-top:64px; margin-bottom: 0px;">
  <p align="center" style="margin-top: 16px;"><strong>PREAMBUŁA</strong></p>
  <p>Postanowienia niniejszej Umowy dotyczą czynności wykonywanych na rzecz Zleceniodawcy przez Fundację w ramach zorganizowanej części przedsiębiorstwa o nazwie {{ nazwaPrzedsiebiorstwa }}, działającą przy Oddziale {{ oddzial }}, reprezentowaną przez {{ imieNazwisko }} (nr tel. {{ nrTelefonu }}). Osoba wskazana w niniejszej preambule zostaje wyznaczona przez Fundację do kontaktu przy realizacji postanowień umowy.</p>
</p>

<p align="center" style="margin-bottom: 0px;">
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 1</strong>
  </p>
  <p align="center" style="margin-bottom: 8px;">
    <strong>[Przedmiot umowy]</strong>
  </p>
</p>
<ol>
  <li>Przedmiotem niniejszej Umowy jest określenie zasad, na jakich Fundacja zobowiązuje się świadczyć na rzecz Zleceniodawcy usługi w zakresie nauczania języka/języków <b>{{ jezyk }}</b> i/lub usług dodatkowych (dalej: <b>„Usługi”</b>). Szczegółowy zakres Usług wskazany będzie w Zamówieniu, o którym mowa w § 2 ust. 5 Umowy.</li>
  <li>W imieniu Fundacji Usługi wykonywane będą przez bezpośredniego wykonawcę, oznaczonego w Preambule Umowy [dalej: <b>„Lektor”</b>], za którego działania lub zaniechania Fundacja ponosi pełną odpowiedzialność, taką jak za swoje działania lub zaniechania.</li>
  <li>Zleceniodawca oświadcza, że w ramach swojej działalności gospodarczej prowadzi szkoły językowe, których usługi obejmują organizację i przeprowadzanie wewnętrznych i zewnętrznych kursów języków obcych (dalej: <b>„Kursy”</b>).</li>
  <li>Fundacja oświadcza i zobowiązuje się, że dysponuje wiedzą, doświadczeniem oraz uprawnieniami niezbędnymi do należytego wykonania Usługi i zobowiązuje się wykonywać je ze szczególną starannością, z uwzględnieniem obowiązujących przepisów prawa, zasad etyki zawodowej, standardów i reguł wykonywania prac objętych niniejszym zleceniem, zgodnie z właściwym Vademecum Lektora - zasadami świadczenia usług lektorskich (dalej: <b>„Vademecum Lektora”</b>), odpowiednim dla danego typu Kurs (B2B lub B2C) i zapewnia, że takie same warunki spełnia Lektor.</li>
  <li>Fundacja oświadcza i zobowiązuje się, że przed przystąpieniem do świadczenia Usług, Lektor zapozna się z właściwym Vademecum Lektora, misją i wizją Zleceniodawcy, przyjętymi standardami oraz obowiązującymi u Zleceniodawcy regulacjami wewnętrznymi oraz zapewni, że Lektor będzie je stosować, a także, iż w razie dokonania ich zmian, zmiany te będą skuteczne pomiędzy Stronami. W szczególności, podczas wykonywania zlecenia, Lektor zobowiązany jest do dbania o dobro Zleceniodawcy i ochrony jego mienia, w tym do dołożenia najwyższej staranności celem zapewnienia zgodności wszystkich podejmowanych czynności z odpowiednimi politykami, standardami, wytycznymi, kodeksami branżowymi i procedurami [dalej łącznie: <b>„Dokumenty”</b>] obowiązującymi u Zleceniodawcy. Zleceniodawca zobowiązuje Fundację, aby Lektor postępował zgodnie z zasadami zawartymi w Dokumentach, a ich nieprzestrzeganie może być podstawą do rozwiązania niniejszej Umowy w trybie natychmiastowym, z przyczyn leżących po stronie Fundacji. Przed przystąpieniem przez Lektora do świadczenia usług, Zleceniodawca prześle Dokumenty na wskazany przez Lektora adres email.</li>
  <li>Fundacja ponosi odpowiedzialność za postępowanie Lektora zgodnie z zasadami zawartymi w niniejszej Umowie, w tym w szczególności w Dokumentach, a każde ich naruszenie przez Lektora może być podstawą do rozwiązania niniejszej Umowy w trybie natychmiastowym, z winy Fundacji.</li>
  <li>Fundacja zapewni zobowiązanie się przez każdego Lektora do zachowania poufności na podstawie odrębnego porozumienia zawartego ze Zleceniodawcą, pod rygorem możliwości wypowiedzenia przez Zleceniodawcę Umowy ze skutkiem natychmiastowym, z winy Fundacji.</li>
  <li>Bez uprzedniej pisemnej zgody Zleceniodawcy, Fundacja nie może wykonywać przedmiotu niniejszej umowy za pośrednictwem innego Lektora, niż wskazanego w ust. 2 powyżej.</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 2</strong>
  </p>
  <p align="center" style="margin-bottom: 8px;">
    <strong>[Zasady świadczenia Usług]</strong>
  </p>
</p>
<ol>
  <li>Strony ustalają, że Usługi świadczone będą w czasie ustalonym przez Zleceniodawcę, w placówkach Zleceniodawcy i/lub poza placówkami Zleceniodawcy, które zostaną uprzednio wskazane Fundacji, , zgodnie z zamówieniem Zleceniodawcy, o którym mowa w ust. 4 poniżej oraz z uwzględnieniem ustalonego między Stronami wynagrodzenia.</li>
  <li>Kursy językowe będą oznaczone kodami identyfikacyjnymi lub nazwami.</li>
  <li>Fundacja w dniu zawarcia Umowy, przedstawi Zleceniodawcy informację o dostępności Lektora oraz propozycję wzajemnej współpracy.  Fundacja zobowiązuje się do niezwłocznego informowania Zleceniodawcy o każdorazowej zmianie zadeklarowanej dostępności Lektora, z zastrzeżeniem, iż zmiana taka możliwa jest jedynie przed złożeniem zamówienia, o którym mowa w ust. 5 poniżej lub w zakresie nieobejmującym realizowane przez Lektora Kursy. Niezależnie od powyższego, Strony ustalają, że uzgodnienia w zakresie dostępności Lektora mogą być dokonywane przez Zleceniodawcę bezpośrednio z Lektorem w formie korespondencji mailowej.</li>
  <li>Informacja o dostępności Lektora oraz propozycja wzajemnej współpracy przekazywana przez Fundację nie zobowiązuje Zleceniodawcy do zlecenia jej świadczenia Usług, ale Zleceniodawca będzie podejmował działania mające na celu jak najszersze zrealizowanie propozycji współpracy.</li>
  <li>W oparciu o informację o dostępności Lektora oraz propozycję wzajemnej współpracy, Zleceniodawca ma prawo złożyć Fundacji zamówienie na świadczenie Usług w ramach określonych Kursów lub usług dodatkowych, którego wzór stanowi Załącznik nr 1 do niniejszej Umowy (dalej: <b>„Zamówienie”</b>). </li>
  <li>Zleceniodawca powiadomi Fundację o zamiarze złożenia Zamówienia telefonicznie, pisemnie lub mailem z uwzględnieniem danych teleadresowych Fundacji określonych w § 8 lit. b Umowy. Strony uzgadniają, że Zamówienie może zostać zawarte wedle wyboru Zleceniodawcy:
    <ol type="a">
      <li>w formie pisemnej, albo</li>
      <li>w formie dokumentowej: 
        <ol type="i">
          <li>za pośrednictwem korespondencji mailowej, albo</li>
          <li>za pośrednictwem platformy Autenti dostępnej pod adresem <a href="https://www.autenti.com/" target="_blank">www.autenti.com</a> (dalej: <b>„Platforma”</b>).</li> 
        </ol>
      </li>
    </ol>
    <p style="margin-top: 16px;">W przypadku zawierania Zamówienia w formie pisemnej Zleceniodawca prześle Fundacji Zamówienie do podpisu (akceptacji). W razie, gdyby Fundacja nie odesłała Zleceniodawcy podpisanego Zamówienia w terminie 3 dni od jego wysłania przez Zleceniodawcę, przyjmuje się, iż odmówiła przyjęcia Zamówienia.</p>
    <p>W przypadku zawierania Zamówienia w formie dokumentowej za pośrednictwem korespondencji mailowej Zleceniodawca prześle Fundacji na wskazany adres mailowy Zamówienie do akceptacji. W przypadku, gdyby Fundacja nie odesłała Zleceniodawcy akceptacji Zamówienia w formie mailowej w terminie 3 dni od dnia wysłania korespondencji przyjmuje się, że odmówiła akceptacji Zamówienia.</p>
    <p>W przypadku zawierania Zamówienia w formie dokumentowej, Zleceniodawca udostępni dokument do podpisu za pośrednictwem Platformy i poinformuje o tym fakcie Fundację. Brak podpisu Zamówienia w terminie 3 dni od dnia poinformowania Fundacji o dostępności dokumentu do podpisu poczytywany będzie za odmowę przyjęcia Zamówienia przez Fundację.</p>
    <li>Zleceniodawca zastrzega sobie możliwość nieutworzenia bądź rozwiązania grupy o kodzie identyfikacyjnym/nazwie podanym w Zamówieniu z ważnych przyczyn (np. ilość osób w grupie spadnie poniżej 60% w stosunku do zakładanego w ofercie maksymalnego stanu, uzasadniona z punktu widzenia Zleceniodawcy prośba jej klientów o zmianę osoby prowadzącej lekcje, itp.).</li>
    <li>Fundacja zobowiązuje się do rzetelnego wypełniania postanowień niniejszej Umowy i lojalnego postępowania wobec Zleceniodawcy.</li>
    <li>Fundacja oświadcza, że zapozna Lektora z przepisami BHP, zagrożeniami związanymi ze świadczonym zleceniem oraz zasadami ochrony ppoż i zobowiąże Lektora do ich przestrzegania.</li>
    <li>W każdym czasie Zleceniodawca uprawniony jest do żądania od Fundacji przedstawiania szczegółowych informacji na temat świadczonych Usług oraz dowodów ich wykonywania. Żądaniu temu Fundacja zobowiązana jest sprostać niezwłocznie.</li>
    <li>Fundacja przedstawia Zleceniodawcy raport zawierający zestawienie liczby godzin świadczenia Usług przez Fundację, który generowany jest z systemu LangLion (dalej: <b>„Rozliczenie”</b>), w każdym okresie rozliczeniowym obejmującym miesiąc kalendarzowy (dalej: <b>„Okres rozliczeniowy”</b>), za pośrednictwem poczty elektronicznej, najpóźniej do 10 dni od zakończenia okresu rozliczeniowego. Jeżeli w danym okresie rozliczeniowym Usługi nie były wykonywane Fundacja wpisuje „0” w Rozliczeniu.</li>
    <li>Zleceniodawca nie później niż w terminie 3 dni roboczych od otrzymania Rozliczenia potwierdza albo odmawia potwierdzenia liczby godzin świadczenia Usług. Informacja o potwierdzeniu albo odmowie potwierdzenia jest przekazywana Spółce za pośrednictwem poczty elektronicznej lub w e- dzienniku.</li>
    <li>Fundacja w terminie do 3 dni roboczych od daty przekazania przez Zleceniodawcę odmowy potwierdzenia liczby godzin świadczenia Usług w danym okresie rozliczeniowym może wnieść reklamację do Zleceniodawcy, za pośrednictwem poczty elektronicznej. W terminie 3 dni roboczych od daty otrzymania reklamacji Zleceniodawca informuje Fundację o sposobie rozpoznania reklamacji za pośrednictwem poczty elektronicznej.</li>
    <li>Strony zgodnie potwierdzają, że czas przygotowania do świadczenia zlecenia, reklamacji, wykonywania korekt lub poprawek nie jest wliczany do czasu świadczenia zlecenia.</li>
  </li>

</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 3</strong>
  </p>
  <p align="center" style="margin-bottom: 8px;">
    <strong>[Zobowiązania Stron]</strong>
  </p>
</p>
  <ol>
    <li>Zleceniodawca zobowiązuje się do:
        <ol type="a">
          <li>zapewnienia pomieszczeń w placówkach w celu należytego wykonania Umowy (w przypadku kursów stacjonarnych);</li>
          <li>Zleceniodawca zapewni pomieszczenia do wykonania Usług (platformę wideokonferencyjną w przypadku kursów online);</li>
          <li>w zależności od przypadku, zapewnienia sprzętu audio, materiałów dydaktycznych oraz ewentualnych innych narzędzi/materiałów niezbędnych do prawidłowej realizacji Umowy przez Fundację.</li>
          </ol>
    </li>
    <li>W ramach świadczenia Usług Fundacja zobowiązuje się do:
      <ol type="a">
        <li>przeprowadzania Kursów językowych w uzgodnionych terminach, zgodnie z: Zamówieniem, właściwym Vademecum Lektora, wskazówkami metodycznymi przygotowanymi przez Zleceniodawcę lub wytycznymi klienta (w przypadku kursów B2B), a także wszelkimi regulacjami obowiązującymi u Zleceniodawcy,</li>
        <li>sporządzania dwa razy w ciągu roku Kart Osiągnięć Słuchaczy dla każdego kursanta, w terminie na jednego tygodnia przed zakończeniem każdego z semestrów, wystawiania świadectw na koniec roku szkolnego i sporządzania rejestru wydanych świadectw oraz systematycznego prowadzenia elektronicznych i/lub papierowych dzienników zajęć. W przypadku kursów zewnętrznych, przygotowywania dokumentów wymaganych przez klienta – zamawiającego Kurs zewnętrzny,</li>
        <li>regularnego przygotowywania i przeprowadzania powtórek materiału w formie krótkich kartkówek oraz w formie ustnych odpowiedzi, a także przygotowywania i przeprowadzania minimum 2 testów w trakcie trwania semestru lub przeprowadzania testów przygotowanych przez Zleceniodawcę. W przypadku kursów zewnętrznych dokonywania ocen w postępie wg. wymagań klienta – zamawiającego Kurs zewnętrzny,</li>
        <li>utrzymywania bieżącego kontaktu z kursantami w sprawach dotyczących nauczania, nieobecności na zajęciach, rezygnacji, itp. poprzez kontakt osobisty, telefoniczny i/lub mailowy,</li>
        <li>dbania o dobry wizerunek Zleceniodawcy wśród osób korzystających z Kursów,</li>
        <li>potwierdzania w dzienniku zajęć liczby świadczonych godzin przez Lektora w każdym miesiącu kalendarzowym, w terminie do pierwszego dnia miesiąca, następującego po miesiącu rozliczeniowym,</li>
        <li>udziału w ewentualnych spotkaniach grona lektorskiego/nauczycielskiego,</li>
        <li>w przypadku prowadzenia kursów online:
          <ol type="i">
            <li>uruchamiania opcji nagrywania każdych zajęć B2C oraz kursów B2B na polecenie Zleceniodawcy;</li>
            <li>sprawdzania listy obecności na każdych zajęciach i odnotowywania w dzienniku elektronicznym; </li>
            <li>zapewnienia sprzętu w postaci: słuchawek z mikrofonem, kamerki internetowej, komputera wraz z oprogramowaniem, niezbędnym do prowadzenia zajęć na platformie wideokonferencyjnej, o parametrach nie mniejszych niż:
              <ul>
                <li>połączenie internetowe min. 512kb/s upload, 4Mb/s download z maksymalnymi opóźnieniami poniżej 100ms (przy czym nie może być to łącze mobilne ani radiowe),</li>
                <li>procesor min. 2 GHz dual-core lub lepszy (4-core preferowany),</li>
                <li>min. 2GB RAM (4 GB zalecane),</li>
                <li>System operacyjny Windows 8 (Windows 10 zalecany), Mac OS 10.13 (najnowsza wersja zalecana), Linux, Chrome OS,</li>
              </ul>
            </li>
          </ol>
        </li>
        <li>monitor (min. 1280x720px) – zalecane 2 monitory;</li>
        <li>rzetelnego wypełniania postanowień niniejszej Umowy oraz zleceń formułowanych na jej podstawie i lojalnego postępowania wobec Zleceniodawcy.</li>
      </ol>
    </li>
    <li>W czasie obowiązywania niniejszej Umowy, Fundacja zobowiązuje się, że Lektor będzie odbywać szkolenia zakreślone przez Zleceniodawcę, a w razie uzasadnionej niemożliwości, w innym dodatkowym zaproponowanym przez Zleceniodawcę terminie. Nieusprawiedliwione nieodbycie szkolenia w formie (w szczególności webinarium) i w czasie wskazanym przez Zleceniodawcę, uprawnia Zleceniodawcę do rozwiązania niniejszej Umowy w trybie natychmiastowym z przyczyn leżących po stronie Fundacji. </li>
    <li>W przypadku prowadzenia kursów online, których immanentną cechą jest rejestrowanie wizerunku lektora i słuchaczy podczas trwania zajęć, Fundacja przyjmuje do wiadomości, że Zleceniodawca będzie utrwalać i udostępniać wizerunek Lektora na platformie wideokonferencyjnej, za pośrednictwem której organizowany jest kurs online, przez okres trwania kursu oraz 2 tygodnie od jego zakończenia lub przez okres 3 miesięcy od zakończenia danych zajęć (w zależności od typu prowadzonych Kursów online).</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 5px;">
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 4</strong>
  </p>
  <p align="center" style="margin-bottom: 8px;">
    <strong>[Wynagrodzenie]</strong>
  </p>
</p>
<ol>
  <li>Z tytułu właściwego wykonywania Usług w danym Okresie rozliczeniowym, Zleceniobiorcy przysługuje wynagrodzenie w wysokości wynikającej ze stawki za jednostkę lekcyjną wskazaną w <b>Zamówieniu</b> i liczby godzin świadczenia Usług wskazanych w <b>Rozliczeniu.</b></li>
  <li>Wynagrodzenie, o którym mowa w ust. 1 powyżej, będzie wypłacane na podstawie prawidłowo wystawionej faktury vat, przy czym podstawę do wystawienia faktury stanowi zaakceptowane Rozliczenie.</li>
  <li>Wynagrodzenie będzie wypłacone przez Zleceniodawcę na wskazany na fakturze VAT numer rachunku bankowego Fundacji, w terminie do 15-tego albo do 25-tego dnia miesiąca następującego po Okresie rozliczeniowym. Termin wypłaty wynagrodzenia uzależniony jest od daty przekazania przez Fundację i akceptacji przez Zleceniodawcę zestawienia liczby godzin zawartego w Rozliczeniu za Okres rozliczeniowy, za który dokonywana jest płatność oraz prawidłowo wystawionej faktury, przy czym Rozliczenie i faktura powinny być przekazane nie później niż 13 dni roboczych przed planowaną datą wypłaty wynagrodzenia.</li>
  <li>Za dzień zapłaty uważa się dzień uznania rachunku bankowego Zleceniodawcy.</li>
  <li>Stawka za jednostkę lekcyjną, wskazana w Zamówieniu może ulec zmianie w przypadku istotnych zmian kursu (np. zmiana liczebności grupy). Zmiana wynagrodzenia będzie ustalana przez obie Strony i przedstawiana w Zamówieniu, zgodnie z procedurą wskazaną w § 2 ust. 6 Umowy. </li>
  <li>Fundacja zobowiązuje się ponosić wszelkie koszty i obciążenia publicznoprawne związane w wykonywaniem Umowy, a w szczególności podatki i składki na ubezpieczenie społeczne oraz wszelkie inne obciążenia publicznoprawne.</li>
  <li>Z zastrzeżeniem przypadków wyraźnie wskazanych w niniejszej Umowie, Fundacja jest zobowiązana do pokrywania wszelkich kosztów związanych z jej wykonaniem.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 5</strong>
  </p>
  <p align="center" style="margin-bottom: 8px;">
    <strong>[Okres obowiązywania Umowy]</strong>
  </p>
</p>
<ol>
  <li>Umowa zostaje zawarta na czas określony tj. od dnia podpisania dokumentu przez obie strony do
dnia {{ umowaDo }}.</li>
  <li>Każdej ze Stron przysługuje prawo wypowiedzenia Umowy lub Zamówienia z zachowaniem jednomiesięcznego okresu wypowiedzenia, skutecznego na koniec miesiąca kalendarzowego, które powinno być dokonane na piśmie, z zastrzeżeniem ust. 4 i 5 poniżej.</li>
  <li>Umowa lub Zamówienie może być rozwiązana przez Zleceniodawcę ze skutkiem natychmiastowym, w przypadku naruszenia istotnych postanowień Umowy przez Fundację. W takim wypadku Zleceniodawca obowiązany jest doręczyć Fundacji w formie pisemnej jasne i szczegółowe wyjaśnienie powstałych naruszeń i uzasadnić tym samym podstawę rozwiązania Umowy.</li>
  <li>Z zastrzeżeniem innych przypadków określonych w Umowie, Zleceniodawca ma prawo do wypowiedzenia umowy ze skutkiem natychmiastowym w przypadku:
    <ol type="a">
      <li>wystąpienia trzech przypadków niewykonania lub nienależytego wykonania Umowy, przez co należy rozumieć również nieobecność Lektora na zajęciach, w tym zajęciach online, bez uprzedniego pisemnego lub mailowego zawiadomienia z 24-godzinnym wyprzedzeniem;</li>
      <li>naruszenia przez Fundację albo Lektora zobowiązania do poufności lub postanowień antykorupcyjnych;</li>
      <li>naruszenia przez Fundację zasad przetwarzania danych osobowych określonych w niniejszej Umowie lub umowie powierzenia przetwarzania danych osobowych;</li>
      <li>przeniesienia praw/wierzytelności lub zobowiązań wynikających z Umowy bez uzyskania uprzedniej pisemnej zgody Zleceniodawcy;</li>
      <li>naruszenie przez jakiekolwiek gwarancji lub zobowiązania odnoszącego się do etycznego zachowania, o ile jest to naruszenie, którego nie można naprawić.</li>
    </ol>
  </li>
  <li>Fundacja może wypowiedzieć niniejszą umowę ze skutkiem natychmiastowym w przypadku:
    <ol type="a">
      <li>gdy Zleceniodawca opóźnia się z zapłatą za co najmniej dwa okresy płatności,</li>
      <li>przeniesienia praw/wierzytelności lub zobowiązań wynikających z Umowy bez uzyskania uprzedniej pisemnej zgody Fundacji.</li>
    </ol>
  </li>
  <li>Wypowiedzenie Umowy jest jednoznaczne z wypowiedzeniem Zamówienia realizowanego na jej podstawie, chyba że Strony postanowią inaczej.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 6</strong>
  </p>
  <p align="center" style="margin-bottom: 8px;">
    <strong>[Klauzula antykorupcyjna]</strong>
  </p>
</p>
  <p>Fundacja oświadcza, iż jej wspólnicy/większościowi udziałowcy/większościowi akcjonariusze/ nie są osobami pełniącymi funkcje publiczne w rozumieniu art. 115 § 19 Kodeksu Karnego, ani nie są instytucjami państwowymi oraz zgodnie z jego najlepszą wiedzą nie pozostają w żadnej relacji służbowej lub osobistej, która mogłaby powodować podejrzenie, że zawarcie niniejszej umowy będzie  sprzeczne z obowiązującymi przepisami antykorupcyjnymi zabraniają m.in. bezpośredniego lub pośredniego przekazywania korzyści majątkowych lub osobistych funkcjonariuszom publicznym, osobom pełniącym funkcje publiczne oraz innym urzędnikom państwowym, a także partiom politycznym lub ich kandydatom w celu uzyskania lub utrzymania korzyści biznesowych.</p>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 7</strong>
  </p>
  <p align="center" style="margin-bottom: 8px;">
    <strong>[Osoby do kontaktu]</strong>
  </p>
</p>
<p>Osobami upoważnionymi ze strony Zleceniodawcy i Fundacji do kontaktów w ramach realizacji przedmiotu Umowy są:</p>
<div class="contact-people">
  <ol type="a" class="grid">
    <li><span >Ze strony Zleceniodawcy</span>:
      <p>imię i nazwisko: {{ zleceniodawcaDane }}</p>
      <p>e-mail: {{ zleceniodawcaEmail }}</p>
      <p>tel.: {{ zleceniodawcaTelefon }}</p>
    </li>
    <li><span>Ze strony Fundacji</span>:
      <p>imię i nazwisko: {{ osobaFundacja }}</p>
      <p>e-mail: {{ osobaFundacjaEmail }}</p>
      <p>tel.: {{ osobaFundacjaTel }}</p>
    </li>
  </ol>
</div>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 8</strong>
  </p>
  <p align="center" style="margin-bottom: 8px;">
    <strong>[Poufność]</strong>
  </p>
</p>
  <ol>
    <li>Fundacja zobowiązana jest do zachowania w tajemnicy wszelkich nieujawnionych do publicznej wiadomości informacji dotyczących Zleceniodawcy, a w szczególności: danych finansowych, tajemnic handlowych, informacji o klientach, cenach zakupu, źródłach zaopatrzenia, danych technicznych, know-how, praktyk handlowych i korporacyjnych, zawieranych przez Zleceniodawcę umów, w których posiadanie wejdzie w związku z zawarciem lub realizacją Umowy.</li>
    <li>Zobowiązanie, o którym mowa w ust. 1, jest wiążące od dnia podpisania Umowy i obowiązuje również po jej wygaśnięciu lub rozwiązaniu.</li>
    <li>Zleceniodawca i Fundacja zobowiązują się do należytego zabezpieczenia dokumentów finansowych oraz komputerów zawierających dokumenty i informacje finansowo-księgowe.</li>
    <li>W przypadku naruszenia tych postanowień przez Fundację lub Lektora, Zleceniodawca ma prawo rozwiązać Umowę ze skutkiem natychmiastowym, z winy Fundacji.</li>
    <li>W razie wątpliwości, Strony zgodnie ustalają, iż decyzja przesądzająca o charakterze określonej informacji należy do Zleceniodawcy. </li>
    <li>Fundacja nie może kopiować, powielać ani przechowywać Informacji Poufnych, chyba, że będzie to robić w celu właściwego wykonywania przedmiotu Umowy. Na żądanie Zleceniodawcy Fundacja zwróci lub zniszczy wszelkie Informacje Poufne będące w jej posiadaniu.</li>
  </ol>
  <br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 9</strong>
  </p>
  <p align="center" style="margin-bottom: 8px;">
    <strong>[Dane osobowe]</strong>
  </p>
</p>
<ol>
  <li>W związku z zawarciem i wykonywaniem Umowy dojdzie do udostępnienia danych osobowych personelu, współpracowników, reprezentantów i pełnomocników Stron. </li>
  <li>Każda ze Stron zobowiązuje się do przekazania osobom, których dane osobowe udostępniła informacji o przetwarzaniu danych osobowych przez drugą Stronę. Informacje te stanowią odpowiednio Załącznik nr 2 i 3 do niniejszej Umowy. Strony zobowiązane są do informowania się wzajemnie o wszelkich zmianach w zakresie tych informacji i przekazywania ich aktualnej treści, która ma być przekazywana osobom, których dane dotyczą.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 10</strong>
  </p>
  <p align="center" style="margin-bottom: 8px;">
    <strong>[Postanowienia końcowe]</strong>
  </p>
</p>
<ol>
  <li>Wszelkie zmiany i uzupełnienia niniejszej Umowy dla swej ważności wymagają formy pisemnej lub dokumentowej.</li>
  <li>W sprawach nieuregulowanych w niniejszej umowie mają zastosowanie przepisy kodeksu cywilnego.</li>
  <li>Wszelkie spory wynikające z niniejszej Umowy Strony poddają pod rozstrzygnięcie sądu według właściwości miejscowej siedziby Zleceniodawcy.</li>
  <li>Umowę sporządzono w dwóch jednobrzmiących egzemplarzach po jednym dla każdej ze Stron.</li>
</ol>
<br>

<div style="margin-top: 24px;">
  <p class="underline"><b>Załączniki:</b></p>
  <ol>
    <li class="underline">Wzór Zamówienia;</li>
    <li class="underline">Informacja Tutore w zakresie przetwarzania danych osobowych;</li>
    <li class="underline">Klauzula Informacyjna FUNDACJI ROZWOJU PRZEDSIĘBIORCZOŚCI „TWÓJ STARTUP”;</li>
    <li class="underline">Pełnomocnictwo wraz z Informacją odpowiadającą odpisowi pełnemu z rejestru przedsiębiorców dla Tutore pobraną na podstawie art. 4 ust. 4aa ustawy z dnia 20 sierpnia 1997 r. o Krajowym Rejestrze Sądowym;</li>
    <li class="underline">Informacja odpowiadająca odpisowi pełnemu z rejestru stowarzyszeń, innych organizacji społecznych i zawodowych, fundacji oraz publicznych zakładów opieki zdrowotnej pobraną na podstawie art. 4 ust. 4aa ustawy z dnia 20 sierpnia 1997 r. o Krajowym Rejestrze Sądowym.</li>
  </ol>
</div>

<div class="cointainer" style="margin-top: 30px; margin-bottom: 30px;">
    <div class="left-cointainer">
        <span><b>{{ zamawiajacy }}</b></span>
        <br>
        <p><b>Zleceniodawca</b></p>
    </div>
    <div class="right-cointainer">
        {{ imieNazwisko }}
        <br>
        <span style="margin-left: 0%;"><b>Fundacja</b></span>
    </div>
</div>

 <div style="margin-top:5px;page-break-before: always;">
   <p class="underline">Załącznik nr 1 do umowy z dn. {{ aktualnaData() }}</p>
   <p align="center" style="margin-top:16px;">WZÓR ZAMÓWIENIA</p>
   <br>
   <p>Imię i nazwisko Zleceniobiorcy: Fundacja Rozwoju Przedsiębiorczości „Twój Startup” lektor : {{ imieNazwisko }}</p>
   <p>Oddział: {{ oddzial }}</p>
   <p><strong>Okres: {{ umowaOd }} - {{ umowaDo }}</strong></p>
   <br>
   <div class="table-container">
    <table class="custom-table">
      <thead>
        <tr>
          <th v-for="(title, index) in tableHeaders" :key="index">{{ title }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ startKursu }}</td>
          <td>{{ koniecKursu }}</td>
          <td>{{ typGrupy }}</td>
          <td>{{ stawka1 ? `${stawka1} zł` : '' }}</td>
          <td>{{ dlugoscLekcja }}</td>
          <td>{{ poziomGrupy }}</td>
          <td>{{ typKursu }}</td>
          <td>{{ miejsceKursu }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <p style="margin-top:32px; margin-bottom: 8px;">Powyższa tabela zawiera stawki godzinowe, które są podstawą do naliczenia wynagrodzenia. Całkowite miesięczne wynagrodzenie będzie wynikać ze stawki godzinowej wskazanej w powyższej tabeli oraz ilości lekcji przeprowadzonych w danym miesiącu.</p>  
  <p>W przypadku, gdy jedna lekcja trwa więcej bądź mniej niż 60 minut to stawka wynagrodzenia za jedną lekcję będzie proporcjonalnie obniżona bądź powiększona.</p>
  <p style="margin-top: 32px; margin-bottom: 0px;">*TYP GRUPY - Kurs B2B, Kurs B2C, Kursy online, Usługi dodatkowe m.in.: dodatkowe ocenianie testów, Konsultacje, Konwersacje, Weryfikacja poziomów potencjalnych kursantów, Przeprowadzenie egzaminów pisemnych i ustnych ze znajomości języka, itp.</p>
  <p style="margin-top: 32px;">*TYP ZAJĘĆ – Online/Stacjonarnie</p>
  <br>
  <span>
    <p class="flex-col">
      <span>{{ aktualnaData() }} {{ zamawiajacy }}</span>
      <span>(data i podpis Menedżera/Dyrektora)</span>
    </p>
    <p>
      Akceptuje zamówienie:
    </p>
    <p class="flex-col">
      <span>{{ aktualnaData() }} {{ imieNazwisko }}</span>
      <span>(data i czytelny podpis Fundacji)</span>
    </p>
  </span>
</div>

<div style="page-break-before: always; margin-top: 30px;">
  <p><strong>Załącznik nr 2 - Informacja Tutore w zakresie przetwarzania danych osobowych</strong></p>
  <p>Na podstawie art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, Tutore Poland Sp. z o.o. informuje:</p>
  <ol>
    <li>Administratorem Danych Osobowych jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, tel.  535 933 870 info@szkolamm.pl, dalej ADO. </li>
    <li>ADO przetwarza dane osobowe w następujących celach, na następującej podstawie i w następującym okresie:
      <ol>
        <li>zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,</li>
        <li>wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,</li>
        <li>potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji, ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa,</li>
        <li>realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku kalendarzowego,</li>
        <li>realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika  składek  na  ubezpieczenie społeczne  i  zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5 lat od końca roku kalendarzowego,</li>
        <li>realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,</li>
        <li>bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,</li>
        <li>zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez Współpracowników za pośrednictwem platformy ClickMeeting lub Zoom, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy) poprzez monitoring i nagrywanie kursów online – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) – Wizerunek i głos Współpracownika będzie przetwarzany przez okres 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych zajęć stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu – szczegółowa klauzula zawarta w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line poniżej,</li>
        <li>zapewnienia możliwości udostępnienia nagrań nowym Pracownikom i Współpracownikom nagrywanie szkoleń online prowadzonych za pomocą platformy Zoom – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
        <li>zapewnienia najwyższych standardów jakości obsługi klienta, w celu szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa Współpracownikom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony Klientów (np. groźby karalne) poprzez monitoring rozmów telefonicznych z Klientami Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
        <li>dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.</li>
      </ol>
    </li>
    <li>ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</li>
    <li>Dane osobowe przechowywane będą przez odpowiedni okres wskazany w ust. 2. Po upływie tego okresu dane osobowe przechowywane w systemach informatycznych podlegają usunięciu, a nośniki informacji przechowujące dane, podlegają zniszczeniu.</li>
    <li>Odbiorcami danych osobowych mogą być:
      <ol>
        <li>organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy odpowiednich przepisów prawa,</li>
        <li>zakłady opieki zdrowotnej w celach związanych z medycyną pracy,</li>
        <li>podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i  systemy informatyczne stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych zapewniających ochronę danych, </li>
        <li>biura księgowe,</li>
        <li>banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy,</li>
        <li>kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej realizacji zawartych umów, a związanych z  zajmowanym przez Zleceniobiorcę stanowiskiem pracy,</li>
        <li>współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Poland Sp. z o.o., w celu umożliwienia współpracownikom kontaktu ze Zleceniobiorcą, </li>
        <li>podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez Zleceniobiorcę z tych usług,</li>
        <li>instytucje ubezpieczeniowe,</li>
        <li>organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy realizacji umowy za granicą),</li>
      </ol>
    </li>
    <li>Osoba której dane są przetwarzane ma prawo:
      <ol type="a">
        <li>dostępu do swoich danych oraz otrzymania ich kopii, </li>
        <li>rawo do sprostowania (poprawiania) swoich danych, </li>
        <li>prawo do ograniczenia przetwarzania, </li>
        <li>prawo do bycia zapomnianym, </li>
        <li>prawo do sprzeciwu, </li>
        <li>prawo do przenoszenia danych, </li>
        <li>prawo do cofnięcia zgody na przetwarzanie,</li>
        <li>prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</li>
      </ol>
    </li>
  <li>W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</li>
  </ol>
</div>


<div style="page-break-before: always; margin-top: 32px;">
  <p class="underline" style="margin-bottom: 0px;"><strong>Załącznik nr 3 - Klauzula Informacyjna FUNDACJI ROZWOJU PRZEDSIĘBIORCZOŚCI „TWÓJ STARTUP”</strong></p>
  <p style="font-size: 12px; font-style: italic;">Administratorem Pani/Pana danych osobowych jest FUNDACJA ROZWOJU PRZEDSIĘBIORCZOŚCI „TWÓJ STARTUP” z siedzibą w Warszawie (adres siedziby: ul. Żurawia 6/12, lok. 766, 00-503 Warszawa).</p>
  <br>
  <br>
  <p><strong>Cele przetwarzania Twoich danych osobowych</strong></p>
  <p>Informujemy, że Twoje dane osobowe będą przetwarzane na podstawie Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 roku w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE ( <b>RODO</b> ) w następujących celach:
    <ol type="a">
      <li>weryfikacji prawidłowości umocowania do działania w imieniu Kontrahenta, w tym weryfikacji powyższych danych w publicznych rejestrach, kontaktowania się w sprawach dotyczących wykonania Umowy i jako prawnie uzasadnionych interesów realizowanych przez Administratora ( podstawa z art. 6 ust.1 lit b i f RODO ). Dane będą przetwarzane do czasu realizacji umowy, zaś w zakresie ich archiwizacji do czasu przedawnienia roszczeń;</li>
      <li>wypełniania wszelkich ciążących na nas obowiązków prawnych w związku z podjętą współpracą (art. 6 ust. 1 lit. c Rozporządzenia), cel ten związany jest z obowiązkami prawnymi przechowania określonych dokumentów przez czas wskazany w przepisach prawa, np.:
        <ol type="i">
          <li>art. 74 ust. 2 pkt 1-8 Ustawy z 29.09.1994 r. o rachunkowości (Dz. U. z 2017 r. poz. 1858);</li>
          <li>art. 86 §1 i 2 Ustawy z dnia 29 sierpnia 1997 r. - Ordynacja podatkowa (Dz. U. 1997 nr 137 poz. 926).</li>
        </ol>
      </li>
      <li>ewentualnego ustalenia, dochodzenia lub obrony przed roszczeniami, co jest naszym prawnie uzasadnionym interesem (podstawa z art. 6 ust. 1 lit. f RODO). Dane będą przetwarzane do czasu przedawnienia roszczeń.</li>
    </ol>
  </p>
  <p><strong>Źródło Danych</strong></p>
  <p>Pani/Pana dane zostały zebrane bezpośrednio w związku z dążeniem do zawarcia umowy lub przekazane przez Kontrahenta będącego jej stroną.</p>
  <p><strong>Przysługujące prawa osobie której dane dotyczą</strong></p>
  <ol type="a" style="margin-bottom: 16px;">
    <li>Prawo dostępu do przetwarzanych przez nas danych osobowych <br />(art. 15 Rozporządzenia);</li>
    <li>Prawo do sprostowania powierzonych danych osobowych, w tym ich poprawianie <br />(art. 16 Rozporządzenia);</li>
    <li>Prawo do usunięcia danych osobowych z naszych systemów tzw. „prawo do bycia zapomnianym” - jeżeli Państwa zdaniem nie ma podstaw do tego, abyśmy przetwarzali Państwa dane, mogą Państwo zażądać, abyśmy je usunęli (art. 17 Rozporządzenia);</li>
    <li>Prawo do ograniczenia przetwarzania danych osobowych - mogą Państwo zażądać, abyśmy ograniczyli przetwarzanie danych osobowych wyłącznie do ich przechowywania lub wykonywania uzgodnionych z Państwem działań, jeżeli posiadamy nieprawidłowe dane na Państwa temat lub przetwarzamy je bezpodstawnie; lub nie chcą Państwo, żebyśmy je usunęli, bo są Państwu potrzebne do ustalenia, dochodzenia lub obrony roszczeń; lub na czas wniesionego przez sprzeciwu względem przetwarzania danych (art. 18 Rozporządzenia);</li>
    <li>Prawo do przenoszenia danych – Mają Państwo prawo otrzymać od nas w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego (np. format „.csv”) dane osobowe dotyczące Państwa, w których posiadaniu jesteśmy na podstawie umowy lub wyrażonej zgody.  Uprawnienie to będzie przysługiwało, gdy będziemy posiadać dane w formacie elektronicznym – w przypadku posiadania danych jedynie w formie papierowej nie będą Państwo mieli możliwości skorzystania z tego uprawnienia. Mogą Państwo zlecić nam przesłanie tych danych bezpośrednio innemu podmiotowi (art. 20 Rozporządzenia);</li>
    <li>Prawo do sprzeciwu - może Pan/Pani wnieść sprzeciw wobec przetwarzania Pana/Pani danych, jeśli podstawą wykorzystania danych jest nasz prawnie uzasadniony interes - art. 21 Rozporządzenia. W takiej sytuacji, po rozpatrzeniu Państwa wniosku, nie będziemy już mogli przetwarzać danych osobowych objętych sprzeciwem na tej podstawie, chyba, że wykażemy, istnienie prawnie uzasadnionych podstaw do przetwarzania danych, które uznaje się za nadrzędne wobec Państwa interesów, praw i wolności;</li>
    <li>Jeżeli w Państwa opinii przetwarzanie danych osobowych narusza przepisy Rozporządzenia, przysługuje Państwu prawo do wniesienia skargi do organu nadzorczego tj. Prezesa Urzędu Ochrony Danych Osobowych.</li>
  </ol>
  <p><strong>Odbiorcy Twoich Danych</strong></p>
  <ol type="a" style="margin-bottom: 16px;">
    <li>Organy władzy publicznej, w zakresie, w którym nie otrzymują danych w ramach konkretnego postępowania na podstawie prawa; </li>
    <li>Podmioty, które przetwarzają Pana/Pani dane osobowe w imieniu Fundacji na podstawie zawartej z Fundacją umowy powierzania przetwarzania danych osobowych (tzw. podmioty przetwarzające) lub osoby upoważnione. Będą to, m.in.: Beneficjenci Fundacji, informatycy, firmy archiwizujące, podmioty świadczące usługi bankowe i płatnicze, firmy hostingowe, pracownicy i współpracownicy;</li>
    <li>Zewnętrzni administratorzy danych (tzw. Równoległy Administrator, któremu dane są udostępniane, np. radcy prawni i adwokaci, podmioty prowadzące działalność kurierską lub pocztową, podmioty nabywające wierzytelności - w razie niezapłacenia przez Państwa naszych faktur w terminie).</li>
  </ol>
  <p><strong>Profilowanie</strong></p>
  <p>Informujemy, iż Państwa dane nie będą podlegać profilowaniu, czyli zautomatyzowanej analizy Pana/Pani danych i opracowania przewidywań na temat preferencji lub przyszłych zachowań (profilowanie oznacza, np. w przypadku profilowania marketingowego określanie, którą ofertą może być Pan/Pani najbardziej zainteresowany/a w oparciu o wcześniejsze Pana/Pani wybory).</p>
  <p><strong>Kontakt</strong></p>
  <p>Jeśli potrzebujecie Państwo dodatkowych informacji związanych z ochroną danych osobowych lub chcecie skorzystać z przysługujących praw, prosimy o kontakt na adres e-mail: <a href="mailto:trodo@twojstartup.pl">trodo@twojstartup.pl</a></p>
</div>

</td>
</tr>

</tbody></table>
  
  </v-container>
</template>

<script>
export default {
  name: 'UmowaFundacja',
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      dataPodpisania: '',
      miejscePodpisania: '',
      nazwaPrzedsiebiorstwa: '',
      oddzial: '',
      zleceniodawcaDane: '',
      zleceniodawcaEmail: '',
      zleceniodawcaTelefon: '',
      fundacjaDane: '',
      fundacjaEmail: '',
      fundacjaTelefon: '',
      lektorOddzial: '',
      lektorOkresUmowy: '',
      podpisFundacja: '',
      startKursu: '',
      koniecKursu: '',
      typGrupy: '',
      dlugoscLekcja: '',
      poziomGrupy: '',
      typKursu: '',
      miejsceKursu: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrUmowy: '',
      datapocz: '',
      datakon: '',
      wypo: '',
      kwotapokaz: '',
      slowniepokaz: '',
      shortUmowa: '',
      obywatelstwo: '',
      nazwaFirmy: '',
      siedzibaFirmy: '',
      nip: '',
      kontoBankowe: '',
      rodzajUmowy: '',
      jezyk: '',
      reprezentujacy: '',
      osobaFundacja: '',
      osobaFundacjaEmail: '',
      osobaFundacjaTel: '',
      // przedmiot: '',
      // przedmiot1: '',
      // stawka1Slownie: '',
      // przedmiot2: '',
      // stawka2: '',
      // stawka2Slownie: '',
      // przedmiot3: '',
      // stawka3: '',
      // stawka3Slownie: '',
      tableHeaders: ['Data startu kursu', 'Data końca kursu', 'Typ grupy', 'Stawka brutto za jedn. lekcyjną','Długość lekcji (min)', 'Poziom', 'Typ zajęć *', 'Miejsce wykonywania zajęć']
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      let shortPosition = ''
      tab = this.nrUmowy.split('/')
      switch(tab[3]) {
        case 'Nauczyciel':
          shortPosition = 'Naucz'
          break;
        case 'Metodyk':
          shortPosition = 'Met'
          break
        case 'TworcaMaterialow':
          shortPosition = 'TMat'
          break
        case 'TworcaMaterialowNauczycielMetodyk':
          shortPosition = 'TMatNauMet'
          break
        case 'TworzenieProgramuNauczania':
          shortPosition = 'TPNau'
          break
        case 'AsystentOrganizacyjny':
          shortPosition = 'AOrg'
          break
        case 'MłodszyAsystentOrganizacyjny':
          shortPosition = 'MAOrg'
          break
        case 'TworzenieMap':
          shortPosition = 'TMapMC'
          break
        default:
          shortPosition = tab[3]
      }
      const shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
      return shortUmowa
    },
    slownieAngielski() {
      switch(this.kwota) {
        case '25':
          return 'twenty-five'
          break
        case '30':
          return 'thirty'
          break
        case '35':
          return 'thirty-five'
          break
        case '40':
          return 'forty'
          break
        case '45':
          return 'forty-five'
          break
        case '50':
          return 'fifty'
          break
        case '55':
          return 'fifty-five'
          break
        case '60':
          return 'sixty'
          break
        case '65':
          return 'sixty-five'
          break
        case '70':
          return 'seventy'
          break
        case '75':
          return 'seventy-five'
          break
        case '80':
          return 'eighty'
          break
        case '85':
          return 'eighty-five'
          break
        case '90':
          return 'ninety'
          break
        case '95':
          return 'ninety-five'
          break
        default:
          return this.slownie
      }
    },
    slowniePokazAngielski() {
      switch(this.kwotapokaz) {
        case '25':
          return 'twenty-five'
          break
        case '30':
          return 'thirty'
          break
        case '35':
          return 'thirty-five'
          break
        case '40':
          return 'forty'
          break
        case '45':
          return 'forty-five'
          break
        case '50':
          return 'fifty'
          break
        case '55':
          return 'fifty-five'
          break
        case '60':
          return 'sixty'
          break
        case '65':
          return 'sixty-five'
          break
        case '70':
          return 'seventy'
          break
        case '75':
          return 'seventy-five'
          break
        case '80':
          return 'eighty'
          break
        case '85':
          return 'eighty-five'
          break
        case '90':
          return 'ninety'
          break
        case '95':
          return 'ninety-five'
          break
        default:
          return this.slowniepokaz
      }
    },
    dataObowiazywaniaUmowy () {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'dnia podpisania umowy przez obie strony'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    zamawiajacyAngielski() {
      if (this.zamawiajacy === 'Marcin Grzelak - Prezes Zarządu') {
        return 'Marcin Grzelak - Chairman of the Board'
      } else {
        return this.zamawiajacy
      }
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if((day+1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = day+'-'+month+'-'+today.getFullYear()
      return todayDate
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>

.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th, td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.right-cointainer {
  text-align: end;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}

.attachments {
  width: 100%;
}

.contact-people {
  margin-top: 32px;
}

.contact-people .grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.contact-people p:first-of-type {
  margin-top: 16px;
}

.green-yellow-background {
  background-color: greenyellow;
}

.yellow-background {
  background-color: yellow;
}

.fit-content {
  width: fit-content;
}

.table-container {
  display: flex;
  justify-content: center;
}

.custom-table {
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;
}

.custom-table th,
.custom-table td {
  border: 1px solid #000;
  padding: 4px 4px 0 0;
  text-align: center;
  overflow-wrap: break-word;
}

.custom-table th {
  background-color: #f0f0f0;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.commented-text {
  font-size: 12px;
  font-style: italic;
  color: #868686;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaFundacja.vue